import React from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { swapLocaleInPath } from '../lib/urls';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { usePreferences } from '../hooks/usePreferences';
import classNames from 'classnames';

export const Header: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const currentLocale = ((params as Record<string, string | undefined>).locale || 'et').toLowerCase();
  const { isAuthenticated, logout } = useAuth();
  const { preferences, updatePreference } = usePreferences();

  // Help link moved to ThreatFilterSection

  return (
    <header className="shadow-md border-b" style={{ backgroundColor: 'var(--bg-header)', borderColor: 'var(--border-light)' }}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to={`/${currentLocale}/`} className="flex items-center">
              <h1 className="text-xl font-bold tc-text-primary">
                {t('app.title')}
              </h1>
            </Link>
            {isAuthenticated && (
              <nav className="ml-6 flex items-baseline space-x-2">
                <Link
                  to="/admin"
                  className={classNames(
                    'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
                    location.pathname.startsWith('/admin')
                      ? 'tc-btn-primary'
                      : 'tc-text-secondary hover:tc-text-primary hover:bg-gray-50'
                  )}
                >
                  {t('navigation.admin')}
                </Link>
              </nav>
            )}
          </div>

          <div className="flex items-center space-x-3">
            

            <select
              value={preferences.language}
              onChange={(e) => {
                const next = (e.target.value || 'et').toLowerCase() as 'en'|'et'|'ru'|'ua';
                updatePreference('language', next);
                const newPath = swapLocaleInPath(location.pathname, next);
                navigate(newPath + location.search);
              }}
              className="tc-input text-sm px-2 py-1 pr-6"
            >
              <option value="en">🇬🇧 English</option>
              <option value="et">🇪🇪 Eesti</option>
              <option value="ru">🇷🇺 Русский</option>
              <option value="ua">🇺🇦 Українська</option>
            </select>

            {/* Theme toggle disabled - forced light theme */}
            {/* <button
              onClick={() => updatePreference('theme', preferences.theme === 'light' ? 'dark' : 'light')}
              className="p-2 rounded hover:bg-gray-100 tc-text-secondary"
              title="Toggle theme"
            >
              {preferences.theme === 'light' ? '🌙' : '☀️'}
            </button> */}

            {isAuthenticated && (
              <button
                onClick={logout}
                className="text-sm tc-text-secondary hover:tc-text-primary transition-colors"
              >
                {t('admin.logout')}
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
